import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_spinner = _resolveComponent("q-spinner");
    return (_openBlock(), _createElementBlock("div", {
        class: "pdf-container fit",
        style: _normalizeStyle(_ctx.props.containerStyle)
    }, [
        (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_q_spinner, {
                key: 0,
                class: "col",
                style: { "align-content": "center" },
                color: "green-7",
                size: "10%"
            }))
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("canvas", {
                    class: "pdf-canvas",
                    ref_for: true,
                    ref: _ctx.setCanvasRef(index),
                    style: _normalizeStyle(_ctx.props.canvasStyle)
                }, null, 4)
            ])), [
                [_vShow, !_ctx.isLoading]
            ]);
        }), 128))
    ], 4));
}
